<template>
  <div class="login-main">
    <img class="posImg logo" @click="goUrl('/')" src="@/assets/image/common/logo-bule.png" />
    <img class="posImg top" src="@/assets/image/login/top.png" />
    <img class="posImg bottom" src="@/assets/image/login/bottom.png" />
    <div class="content">
      <div class="img-box">
        <img src="@/assets/image/login/img-icon.png" />
        <div class="text-box">
          <span class="share">{{ $t("login.titleBox.title1") }}</span>
          <span>{{ $t("login.titleBox.title2") }}</span>
        </div>
      </div>
      <div class="content-box">
        <div class="herder" v-if="type === 1">
          {{ $t("login.titleBox.title22") }}
        </div>
        <div class="herder" v-if="type === 2">
          {{ $t("login.titleBox.title24") }}
        </div>
        <div class="from-box" v-if="type === 1">
          <div class="title">{{ $t("login.titleBox.title5") }}</div>
          <input v-model="phone" :placeholder="$t('login.titleBox.title7')" />
        </div>
        <div class="from-box" v-if="type === 1">
          <div class="title">{{ $t("login.titleBox.title28") }}</div>
          <div class="button-box">
            <input
              v-model="validCode"
              :placeholder="$t('login.titleBox.title8')"
            />
            <button
              type="primary"
              :class="timer ? 'timer' : ''"
              :disabled="timer"
              @click="getPasswordCode"
            >
              {{ timer ? time + $t("login.titleBox.title29") : $t("login.titleBox.title30") }}
            </button>
          </div>
        </div>
        <div class="from-box" v-if="type === 2">
          <div class="title">{{ $t("login.titleBox.title31") }}</div>
          <input
            type="password"
            v-model="newPassword"
            :placeholder="$t('login.titleBox.title17')"
          />
        </div>
        <div class="from-box" v-if="type === 2">
          <div class="title">{{ $t("login.titleBox.title25") }}</div>
          <input
            type="password"
            v-model="confirmPassword"
            :placeholder="$t('login.titleBox.title17')"
          />
        </div>
        <div class="from-box from-box2" v-if="type === 2">
          <div class="btn" @click="type = 1">{{ $t("login.titleBox.title32") }}</div>
        </div>
        <div class="sunmit" v-if="type === 1" @click="type = 2">
          {{ $t("login.titleBox.title23") }}
        </div>
        <div
          class="sunmit sunmit2"
          v-if="type === 2"
          @click="getForgotPassword"
        >
          {{ $t("login.titleBox.title26") }}
        </div>
        <div class="footer">
          <div class="left" @click="goUrl('/login')">
            {{ $t("login.titleBox.title27") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPasswordCode, getForgotPassword } from "@/api/user";
export default {
  data() {
    return {
      checked: false,
      type: 1,
      timer: null,
      time: 180,

      phone: null,
      validCode: null,
      newPassword: null,
      confirmPassword: null,
    };
  },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    //手机验证码
    getPasswordCode() {
      if (!this.phone) {
        this.$message.warning(this.$t("login.titleBox.title33"));
        return;
      }
      getPasswordCode({
        phone: this.phone,
      }).then((res) => {
        if (res.code === 200) {
          this.timer = setInterval(() => {
            this.time = this.time - 1;
            if (this.time === 1) {
              this.time = 180;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },

    //修改密码
    getForgotPassword() {
      getForgotPassword({
        phone: this.phone,
        validCode: this.validCode,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t("login.titleBox.title34"));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-main {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  .posImg {
    position: absolute;
    z-index: 1;
  }
  .logo {
    width: 156px;
    height: 52.5px;
    top: 46px;
    left: 147px;
    cursor: pointer;
  }
  .top {
    width: 246px;
    height: 226px;
    top: 0;
    right: 0;
  }
  .bottom {
    width: 246px;
    height: 229px;
    bottom: 0;
    left: 0;
  }
  .content {
    width: 1032px;
    height: 550px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    display: flex;
    box-shadow: 0px 0px 30px 1px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    .img-box {
      flex-shrink: 0;
      width: 50%;
      background: #f3edfd;
      img {
        width: 425px;
        height: 380px;
        margin-top: 70px;
        margin-left: 46px;
      }
      .text-box {
        display: flex;
        font-size: 22px;
        justify-content: center;
        margin-top: 28px;
        .share {
          margin-right: 42px;
          color: #8948ff;
        }
      }
    }
    .content-box {
      width: 50%;
      .herder {
        display: flex;
        color: #232323;
        font-size: 20px;
        font-weight: bolder;
        margin-top: 39px;
        justify-content: center;
        width: 370px;
        margin-left: 67px;
        div {
          cursor: pointer;
        }
        .active {
          color: #8948ff;
        }
      }
      .from-box {
        width: 370px;
        margin-left: 67px;
        .title {
          margin-top: 32px;
          font-size: 14px;
          color: #232323;
          margin-bottom: 13px;
        }
        .code-box {
          display: flex;
          justify-content: space-between;
          input {
            width: 220px;
            flex-shrink: 0;
          }
          img {
            flex-shrink: 0;
            width: 130px;
            height: 48px;
          }
        }
        .button-box {
          position: relative;
          input {
            padding-right: 100px;
            box-sizing: border-box;
          }
          button {
            position: absolute;
            cursor: pointer;
            right: 10px;
            background-color: #fafafa;
            top: 50%;
            transform: translateY(-50%);
            border: none;
            color: #6556fa;
            cursor: pointer;
          }
          .timer {
            cursor: no-drop;
            opacity: 0.5;
          }
        }
        .btn {
          color: #6556fa;
          margin-top: 20px;
          cursor: pointer;
        }
        input {
          border: none;
          outline: none;
          background-color: #fafafa;
          width: 100%;
          height: 48px;
          font-size: 14px;
          padding: 0 24px;
          box-sizing: border-box;
        }
        input::placeholder {
          color: #999;
          opacity: 1;
        }
      }
      .from-box2 {
        display: flex;
        justify-content: flex-end;
      }
      .flot {
        float: left;
        margin-left: 67px;
        margin-top: 19px;
        color: #6556fa;
        font-size: 14px;
        cursor: pointer;
      }
      .sunmit {
        display: block;
        border: none;
        padding: 0;
        width: 370px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #8846ff;
        border-radius: 4px 4px 4px 4px;
        margin-left: 67px;
        margin-top: 50px;
        cursor: pointer;
        color: #fff;
      }
      .sunmit2 {
        margin-top: 20px;
      }
      .checkbox-fa {
        width: 370px;
        margin-left: 67px;
        display: flex;
        margin-top: 40px;
        align-items: center;
        .text {
          font-size: 14px;
          color: #232323;
          margin-left: 3px;
          span {
            color: #8948ff;
          }
        }
      }
      .footer {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 370px;
        margin-left: 67px;
        margin-top: 30px;
        .left {
          color: #8948ff;
          cursor: pointer;
        }
        .right {
          display: flex;
          color: #232323;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-left: 21px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1100px) {
  .login-main {
    .content {
      width: 516px;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
      }
    }
  }
}
/* 媒体查询 */
@media only screen and (max-width: 750px) {
  .login-main {
    background-color: #f7f8fa;
    .logo {
      width: 104px;
      height: 35px;
      top: 15px;
      left: 15px;
    }
    .top {
      display: none;
    }
    .bottom {
      display: none;
    }
    .content {
      width: calc(100% - 30px);
      margin-left: 15px;
      left: 0;
      transform: translateY(-50%);
      padding: 15px;
      box-sizing: border-box;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
        .herder {
          display: flex;
          color: #232323;
          font-size: 20px;
          font-weight: bolder;
          margin-top: 39px;
          justify-content: center;
          width: 100%;
          margin-left: 0;
          div {
            cursor: pointer;
          }
          .active {
            color: #8948ff;
          }
        }
        .from-box {
          width: 100%;
          margin-left: 0;
          .title {
            margin-top: 32px;
            font-size: 14px;
            color: #232323;
            margin-bottom: 13px;
          }
          .code-box {
            display: flex;
            justify-content: space-between;
            input {
              width: 220px;
              flex-shrink: 0;
            }
            img {
              flex-shrink: 0;
              width: 130px;
              height: 48px;
            }
          }

          input {
            border: none;
            outline: none;
            background-color: #fafafa;
            width: 100%;
            height: 48px;
            font-size: 14px;
            padding: 0 24px;
            box-sizing: border-box;
          }
          input::placeholder {
            color: #999;
            opacity: 1;
          }
        }

        .flot {
          float: left;
          margin-left: 0;
          margin-top: 19px;
          color: #6556fa;
          font-size: 14px;
          cursor: pointer;
        }
        .sunmit {
          display: block;
          border: none;
          padding: 0;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #8846ff;
          border-radius: 4px 4px 4px 4px;
          margin-left: 0;
          margin-top: 50px;
          cursor: pointer;
          color: #fff;
        }
        .checkbox-fa {
          width: 100%;
          margin-left: 0;
          display: flex;
          margin-top: 40px;
          align-items: center;
          .text {
            font-size: 14px;
            color: #232323;
            margin-left: 3px;
            span {
              color: #8948ff;
            }
          }
        }
        .footer {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-left: 0;
          margin-top: 30px;
          .left {
            color: #8948ff;
            cursor: pointer;
          }
          .right {
            display: flex;
            color: #232323;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
              margin-left: 21px;
            }
          }
        }
      }
    }
  }
}
</style>